import {
  getMockPrivateLessonsPortalData,
  MOCK_PRIVATE_LESSONS_REGISTER_TOKEN,
  PrivateLessonsPortalMockData
} from '../mocks/privateLessonsPortalMock'

/**
 * Resolves portal UI data for a register token.
 * Mock/demo data is only returned for the explicit demo token so real order IDs
 * never surface fabricated receipt or session content.
 */
export const resolvePrivateLessonsPortalData = (
  registerToken: string | undefined
): PrivateLessonsPortalMockData | null => {
  if (registerToken !== MOCK_PRIVATE_LESSONS_REGISTER_TOKEN) {
    return null
  }
  return getMockPrivateLessonsPortalData(registerToken)
}
